package modysy.model

import modysy.simulation.pp.State

/** Models an population protocol agent, that has a circular shape inferred from the state.
  *
  * @param body         The rigid body of the agent, containing position, velocity and material information.
  *                     The geometry of the body will be overwritten with a Circle with the radius inferred from state.
  * @param initialState The initial state of the agent.
  */
class Agent(
    override val body: RigidBody,
    initialState: State
) extends GameObject(body) {
  private var _state: State = initialState
  private var previousRadius: Double = 0
  state = initialState

  /** Infer the color from the current state. */
  override def color: String = state.deducedAgentColor

  def state: State = _state

  var behaviour_active: Boolean = false

  /** Set the new state.
    *
    * If the radius associated with that state is different from the old radius, update
    * the geometry of the body and recalculate its physical parameters.
    */
  def state_=(newState: State): Unit = {
    _state = newState
    if (_state.deducedAgentRadius != previousRadius) {
      body.geometry = Circle(_state.deducedAgentRadius)
      previousRadius = _state.deducedAgentRadius
      body.recalculateMassAndInertia()
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/model/Agent.scala